import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAptitudeImage } from '../../../utils/aptitudeRanks';


const CharacterAptitudesDisplay = ({ aptitudes }) => {
    const { t } = useTranslation();

    const categories = {
        [t('AptitudePanel.category_track')]: ['turf', 'dirt'],
        [t('AptitudePanel.category_distance')]: ['short_distance', 'mile', 'medium_distance', 'long_distance'],
        [t('AptitudePanel.category_style')]: ['runner', 'leader', 'betweener', 'chaser']
    };

    const AptitudeItem = ({ aptKey }) => {
        const rank = aptitudes ? aptitudes[aptKey] : '-';
        const rankImgSrc = getAptitudeImage(rank);
        const label = t(`AptitudeValues.${aptKey}`);

        return (
            <div className="flex flex-col items-center justify-center p-3 bg-gray-50 rounded-xl border border-gray-100 hover:border-primary-green transition-colors w-24">
                <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 text-center">
                    {label}
                </span>
                <div className="h-10 w-10 flex items-center justify-center">
                    {rankImgSrc ? (
                        <img src={rankImgSrc} alt={rank} className="h-full w-full object-contain drop-shadow-sm" />
                    ) : (
                        <span className="text-gray-400 text-xl font-bold">-</span>
                    )}
                </div>
            </div>
        );
    };

    if (!aptitudes || Object.keys(aptitudes).length === 0) {
        return (
            <div className="bg-card-white rounded-2xl shadow-xl p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('CharacterAptitudesDisplay.title')}</h2>
                <p className="text-gray-500">{t('CharacterAptitudesDisplay.empty_msg')}</p>
            </div>
        );
    }

    return (
        <div className="bg-card-white rounded-2xl shadow-xl p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2">{t('CharacterAptitudesDisplay.title')}</h2>

            <div className="space-y-8">
                {Object.entries(categories).map(([categoryName, aptKeys]) => (
                    <div key={categoryName}>
                        <h3 className="text-md font-bold text-primary-green uppercase tracking-widest mb-4 flex items-center gap-2">
                            <span className="w-1 h-4 bg-primary-green rounded-full"></span>
                            {categoryName}
                        </h3>
                        <div className="flex flex-wrap gap-3">
                            {aptKeys.map(aptKey => (
                                <AptitudeItem key={aptKey} aptKey={aptKey} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CharacterAptitudesDisplay;
// Revisado: 2025-12-18 [I18n Scan]
